<div class="card" style="position: relative">
    <span class="page-title"><i class="pi pi-chart-line page-title-icon mr-3"></i>&nbsp;Generate
        Reports</span>
    <p-toast></p-toast>
    <div class="search-partners-header">
        <p-tabView>
            <p-tabPanel header="Involuntary Retrenchment Report">
                <app-involuntary-report
                    [policyStatuses]="policyStatuses"
                    [users]="users"
                    [canFilterByUser]="canFilterByUser"
                    (loadingChange)="onLoadingChange($event)"
                ></app-involuntary-report>
            </p-tabPanel>
            <p-tabPanel header="Road User Accident Cover Report">
                <app-road-user-report
                    [policyStatuses]="policyStatuses"
                    [users]="users"
                    [canFilterByUser]="canFilterByUser"
                    (loadingChange)="onLoadingChange($event)"
                ></app-road-user-report>
            </p-tabPanel>
            <p-tabPanel header="Travel Insurance Report">
                <app-travel-report (loadingChange)="onLoadingChange($event)"></app-travel-report>
            </p-tabPanel>
            <p-tabPanel header="Customer Reports">
                <app-customer-report (loadingChange)="onLoadingChange($event)"></app-customer-report>
            </p-tabPanel>
            <p-tabPanel header="Scholars Report">
                <app-scholars-report
                    [policyStatuses]="policyStatuses"
                    [users]="users"
                    [canFilterByUser]="canFilterByUser"
                    (loadingChange)="onLoadingChange($event)"
                ></app-scholars-report>
            </p-tabPanel>
        </p-tabView>
    </div>
    <p-dialog [(visible)]="visible" [modal]="true" [closable]="false"
        [style]="{ width: screenWidth < 900 ? '65vw' : '35vw' }">
        <app-loading [message]="loadingMessage"></app-loading>
    </p-dialog>
</div>
